import {AppUI, DisplayOrientation, Template, DocumentType} from '@identy/identy-ocr';

export class MenuSelection {
  public run_face: boolean = true;
  public run_finger: boolean = true;
  public card_type: DocumentType;

}
